module.exports = __webpack_public_path__ + "static/media/unitiva_certiquality.87b06eb3.pdf";